var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":"/"}},[_c('h1',{class:_vm.status === 'page' ? 'prjPage' : ''},[_c('span',{attrs:{"id":"title__top"}},[_vm._v("OUT/OF")]),_c('br'),_c('span',{attrs:{"id":"title__bottom"}},[_vm._v("Office")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }